(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .factory('vendorManagementPolicyService', vendorManagementPolicyService);

  /* ngInject */
  function vendorManagementPolicyService($resource, config) {
    let url = `${config.vmsApiEndpoint}/api/vendor_management_policies/:id`;
    let paramDefaults = {id: '@id'};
    let headers = authToken => ({'Authorization': 'Token token=' + authToken});
    let actions = authToken => ({
      'query': { method: 'GET', isArray: true, headers: headers(authToken) },
      'get': { method: 'GET', headers: headers(authToken) },
      'create': { method: 'POST', headers: headers(authToken) },
      'update': { method: 'PUT', headers: headers(authToken) },
      'destroy': { method: 'DELETE', headers: headers(authToken) }
    });

    return authToken => $resource(url, paramDefaults, actions(authToken));
  }
})();
